export default "__VITE_ASSET__34b7b332__"